export const WN_TRACE_EVENT = 'WN_TRACE';
export const WN_APP_VERSION_EVENT = 'WN_APP_VERSION';
export const WN_NAVIGATE_EVENT = 'WN_NAVIGATE';

export const WN_EVENT_WP_APPLICATION = 'YWU: 360 Wealth Planner';
export type WNEventFeature =
    | 'general'
    | 'client-session'
    | 'needs'
    | 'events'
    | 'wealth-overview'
    | 'cashflow'
    | 'projections'
    | 'liquidity-planner'
    | 'family-tree'
    | 'roadmap'
    | 'calculators'
    | 'presentation-mode'
    | 'client-package';

export interface IWNApplicationTrace {
    application?: string;
    feature: WNEventFeature;
    tags: {
        partnerUuid: string;
        action: string;
        [key: string]: string;
    };
}

export function wnSendTrace({ application = WN_EVENT_WP_APPLICATION, feature, tags }: IWNApplicationTrace) {
    window.dispatchEvent(
        new CustomEvent<IWNApplicationTrace>(WN_TRACE_EVENT, {
            detail: { application, feature, tags },
        }),
    );
}

const navigationFeatureMap: Record<string, WNEventFeature> = {
    sessions: 'client-session',
    topics: 'needs',
    events: 'events',
    'wealth-overview': 'wealth-overview',
    'wealth-cashflow': 'cashflow',
    scenarios: 'projections',
    'liquidity-planner': 'liquidity-planner',
    'family-tree': 'family-tree',
    roadmap: 'roadmap',
    calculators: 'calculators',
};

export function wnSendTraceNavigationChange(url: string, partnerUuid: string) {
    const urlSplit = url.split('/');
    const isSessionView = urlSplit.length > 3;
    const featureUrl = urlSplit[urlSplit.length - 1];

    wnSendTrace({
        feature: navigationFeatureMap[featureUrl],
        tags: { partnerUuid, action: 'click-navigation-item', isSessionView: `${isSessionView}` },
    });
}

export interface IWNAppVersion {
    applicationName: string;
    version?: string;
}

export function wnSendAppVersion(version?: string) {
    window.dispatchEvent(
        new CustomEvent<IWNAppVersion>(WN_APP_VERSION_EVENT, {
            detail: { applicationName: WN_EVENT_WP_APPLICATION, version },
        }),
    );
}

export function wnSendPresentationMode(isPresentationModeOn: boolean) {
    window.dispatchEvent(new CustomEvent(isPresentationModeOn ? 'PRESENTATION_MODE_ON' : 'PRESENTATION_MODE_OFF'));

    // Trigger the fullscreen event (open/close) on presentation-mode change to ensure the fullscreen in the WN
    if (isPresentationModeOn && !document.fullscreenElement) {
        document.documentElement.requestFullscreen?.();
    } else if (!isPresentationModeOn && !!document.fullscreenElement) {
        document.exitFullscreen?.();
    }
}

export function wnSendNavigate(route: string) {
    window.dispatchEvent(new CustomEvent(WN_NAVIGATE_EVENT, { detail: route }));
}
